import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { coverFor, ownerLabel, projectPath } from "../data/projects";
import { colors } from "../ui/tokens";

// Case-study card: image panel, then client · category, title and summary.
export default function ProjectCard({ project, large = false }) {
  const { t, i18n } = useTranslation("ProjectsDetails");
  const { t: tc } = useTranslation("Common");
  const p = (k) => t(`${project.key}.${k}`);
  // Keep the arrow on the same line as the last word of the title.
  const words = p("name").split(" ");
  const lastWord = words.pop();

  return (
    <Box
      component={Link}
      to={projectPath(project)}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        textDecoration: "none",
        color: "inherit",
        "&:hover .cover img": { transform: "scale(1.025)" },
        "&:hover .title-arrow": { transform: "translateX(4px)", opacity: 1 },
      }}
    >
      <Box
        className="cover"
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: "14px",
          backgroundColor: project.coverDark ? colors.navyDeep : colors.panel,
          aspectRatio: large ? { xs: "4 / 3", md: "16 / 9" } : "4 / 3",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={coverFor(project, i18n.language)}
          alt={p("name")}
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: project.coverDark ? "cover" : "contain",
            p: project.coverDark ? 0 : { xs: 2, md: large ? 4 : 3 },
            transition: "transform .5s ease",
          }}
        />
      </Box>
      <Box sx={{ pt: 2.5 }}>
        <Typography sx={{ fontSize: "0.82rem", fontWeight: 600, color: colors.muted, mb: 0.75 }}>
          {ownerLabel(project, tc)}
          <Box component="span" sx={{ mx: 1, opacity: 0.5 }}>·</Box>
          {p("category")}
        </Typography>
        <Typography
          component="h3"
          sx={{ fontSize: large ? { xs: "1.4rem", md: "1.9rem" } : { xs: "1.2rem", md: "1.3rem" }, fontWeight: 700, letterSpacing: "-0.01em", lineHeight: 1.25, color: colors.ink }}
        >
          {words.length > 0 && `${words.join(" ")} `}
          <Box component="span" sx={{ whiteSpace: "nowrap" }}>
            {lastWord}
            <ArrowForwardIcon
              className="title-arrow"
              sx={{ fontSize: "0.9em", ml: 0.75, verticalAlign: "-0.1em", opacity: 0.35, transition: "transform .2s, opacity .2s" }}
            />
          </Box>
        </Typography>
        <Typography sx={{ mt: 1, color: colors.body, maxWidth: large ? 640 : "none" }}>{p("summary")}</Typography>
      </Box>
    </Box>
  );
}
